function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { pushTrackingEvent } from "./tracking";
var Breadcrumb = /*#__PURE__*/function (_lm$Composant) {
  function Breadcrumb(id) {
    var _this;
    _classCallCheck(this, Breadcrumb);
    _this = _callSuper(this, Breadcrumb, [id]);
    _this.initSharePageEvent();
    // Init code
    var isScrolable = document.querySelector('.m-breadcrumb__container');
    if (isScrolable) {
      var isScrolableId = isScrolable.id;
      if (isScrolableId) {
        var slider = document.querySelector('#scrollableBreadcrumb');
        var isDown = false;
        var startX;
        var scrollLeft;
        slider.scrollLeft = 1000;
        slider.addEventListener('mousedown', function (e) {
          isDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', function () {
          isDown = false;
        });
        slider.addEventListener('mouseup', function () {
          isDown = false;
        });
        slider.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          var x = e.pageX - slider.offsetLeft;
          var walk = (x - startX) * 3; //scroll-fast
          slider.scrollLeft = scrollLeft - walk;
        });
      }
    }
    return _this;
  }
  _inherits(Breadcrumb, _lm$Composant);
  return _createClass(Breadcrumb, [{
    key: "initSharePageEvent",
    value: function initSharePageEvent() {
      var shareData = {
        text: document.title,
        url: globalThis.location.href
      };
      var breadcrumbComponentContainer = document.querySelector("#component-breadcrumb");
      var shareButtonContainer = breadcrumbComponentContainer === null || breadcrumbComponentContainer === void 0 ? void 0 : breadcrumbComponentContainer.querySelector(".js-breadcrumb-share-page");
      if (navigator.share && navigator.canShare(shareData)) {
        shareButtonContainer === null || shareButtonContainer === void 0 || shareButtonContainer.addEventListener('click', function () {
          navigator.share(shareData).then(function () {
            var productId = (breadcrumbComponentContainer === null || breadcrumbComponentContainer === void 0 ? void 0 : breadcrumbComponentContainer.dataset.productId) || null;
            if (productId) {
              pushTrackingEvent('button.click', {
                button_location: 'product detail page',
                button_name: 'product sharing',
                product_id: productId
              });
            }
          })["catch"](function (error) {
            console.error('Error sharing page:', error);
          });
        });
      } else if (shareButtonContainer) {
        shareButtonContainer.classList.add('kl-hidden');
      }
    }
  }]);
}(lm.Composant);
var BreadcrumbModule = new Breadcrumb("breadcrumb");
lm.sentry.configureScope(function (scope) {
  scope.setTag("kobi.composant", "breadcrumb");
});